type StrapiEntity = Record<string, unknown>

const isRecord = (value: unknown): value is StrapiEntity =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

/**
 * TODO(strapi-v5): Remove v4 relation-shape compatibility once the Strapi v5
 * migration is complete.
 *
 * Accepts both Strapi v4 `{ data: { attributes } }` relations and Strapi v5's
 * flattened relation values. Keeping this at the CMS boundary prevents the
 * component from depending on one response shape while the v5 migration is in
 * progress.
 */
export const relationItems = (value: unknown): StrapiEntity[] => {
  if (value == null) return []

  if (Array.isArray(value)) {
    return value.flatMap(relationItems)
  }

  if (!isRecord(value)) return []

  if ('data' in value) {
    return relationItems(value.data)
  }

  const attributes = isRecord(value.attributes) ? value.attributes : null
  if (!attributes) return [value]

  return [{
    ...attributes,
    ...(value.id != null ? { id: value.id } : {}),
    ...(value.documentId != null ? { documentId: value.documentId } : {}),
  }]
}

/**
 * Individually selected products always appear first. Shared-set products then
 * retain the page's set order and each set's configured product order.
 */
export const resolveProductCards = (block: unknown): StrapiEntity[] => {
  if (!isRecord(block)) return []

  const customProducts = relationItems(block.products)
  const sharedProducts = relationItems(block.sharedSet)
    .flatMap((sharedSet) => relationItems(sharedSet.products))

  return [...customProducts, ...sharedProducts]
}
